import React, { useEffect, useState } from 'react'
import { GetAll_Active_Object_Field_Value_Api } from '../../API/ObjectFieldValueApi';
// ======================================================================
export const ObjectFieldsComponent = ({ setLoading, showMessage, objectInstanceId }) => {
    // ======================================================================
    const [fieldValues, setFieldValues] = useState();
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [objectInstanceId]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Active_Object_Field_Value_Api(objectInstanceId);
            setLoading(false);
            if (data.messageStatus == "Successful")
                setFieldValues(data.messageData.data);
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (

        (fieldValues) ?
            <>
                {fieldValues.map((fv, key) =>
                    <p key={key}>
                        <span>{fv.fieldTitle}: </span>
                        <span >{fv.value}</span>
                    </p>
                )}
            </> : <></>
    )
}
